import shortid from "shortid";
import { constantes } from "../../add-documento-frete/resources/constantes";

export class FormatCte {

  constructor(body, cfop, transportadorId) {
    const estados = constantes.estados;
    const tipoFreteList = constantes.tipoFreteList;
    const indiceFrete = Number(body.frete.tpCTe);

    this.dataEmissao = body.frete.dhEmi;
    this.serieDocumento = body.frete.serie;
    this.numeroDocumento = body.frete.nCT;
    this.cfopId = cfop[0]?.id;
    this.especie = 0;
    this.modeloDocumento = body.frete.mod;
    this.tipoFrete = indiceFrete < 3 
      ? tipoFreteList[indiceFrete] 
      : tipoFreteList[4];
    this.chave = body.frete.cCT;
    this.transportadorId = transportadorId;
    this.ufId = estados.find(({codigo}) => 
      codigo === Number(body.frete.cUF))?.id;
    this.rntrc = body.transportadora.RTRNC;
    this.valorFrete = body.valorPrestado.Comp.find(
      ({xNome}) => xNome.toUpperCase() === "FRETE")?.vComp;
    this.valorSeguro = body.valorPrestado.Comp.find(
      ({xNome}) => xNome.toUpperCase() === "SEGURO")?.vComp;
    this.listaNfe = body.itens.map(({infNFe}) => ({
      id: shortid.generate(),
      valorNfe: 0,
      pesoNfe: 0,
      chaveNfe: infNFe.chave
    }));
  }
}
